module.exports = __webpack_public_path__ + "images/emoji/warning.3829ddb33857dc99c531.png";